import { LenderLoanTypeList } from "constants/loanTypes";

export const maxProceedsOptions = [
  { label: "≤ 80% LTV", value: 0.80 },
  { label: "≤ 75% LTV", value: 0.75 },
  { label: "≤ 70% LTV", value: 0.70 },
  { label: "≤ 65% LTV", value: 0.65 },
  { label: "≤ 60% LTV", value: 0.60 },
  { label: "≤ 55% LTV", value: 0.55 },
  { label: "Max Proceeds (All)", value: 0 }
];

export const noiAdjustmentOptions = [
  { label: "NOI +5%", value: 5 },
  { label: "NOI +0%", value: 0 },
  { label: "NOI -5%", value: -5 }
];

export const RefiAnalysisType = {
  REFI: "Refi Proceeds",
  CASHOUT: "Cash Out Proceeds"
};

export const RefiAnalysisTypeOptions = [
  {
    name: RefiAnalysisType.CASHOUT,
    index: 0,
    calculationType: "loanProceeds",
    resultType: "cashout"
  }, {
    name: RefiAnalysisType.REFI,
    index: 1,
    calculationType: "loanProceeds",
    resultType: "loanProceeds"
  }
];

export const SamplePropertyMetrics = [
  {
    label: "Market Value",
    format: "CURRENCY",
    metricId: "marketValue"
  },
  {
    label: "NOI",
    format: "CURRENCY",
    metricId: "noi",
    adjust: (value, _values, noiAdjustment) => {
      if (noiAdjustment) {
        return value * (1 + (noiAdjustment / 100));
      }

      return value;
    }
  },
  {
    label: "Cap Rate",
    format: "PERCENT",
    metricId: "capRate",
    adjust: (value, values, noiAdjustment) => {
      if (noiAdjustment && values.noi && values.marketValue) {
        const noi = values.noi * (1 + (noiAdjustment / 100));

        return noi / values.marketValue;
      }

      return value;
    }
  },
  {
    label: "Occupancy",
    format: "PERCENT",
    metricId: "occupancy"
  }
];

const generateRefiProceeds = () => LenderLoanTypeList.map(({ name }, idx) => ({
  lender: name,
  proceedsAmount: 25540000,
  ltv: 0.45 + (idx * 0.05),
  dy: 0.095,
  dscr: 1.25
}));

const generateCashOutProceeds = () => LenderLoanTypeList.map(({ name }, idx) => ({
  lender: name,
  proceedsAmount: 1000000,
  ltv: 0.45 + (idx * 0.05),
  dy: 0.035,
  dscr: 2.25
}));

export const SampleRefiAnalysisProceeds = [
  {
    refiAnalysisType: "Refi Proceeds",
    proceeds: [
      { term: 3, lenderProceeds: generateRefiProceeds() },
      { term: 5, lenderProceeds: generateRefiProceeds() },
      { term: 7, lenderProceeds: generateRefiProceeds() },
      { term: 10, lenderProceeds: generateRefiProceeds() },
      { term: 15, lenderProceeds: generateRefiProceeds() },
      { term: 20, lenderProceeds: generateRefiProceeds() },
      { term: 25, lenderProceeds: generateRefiProceeds() }
    ]
  },
  {
    refiAnalysisType: "Cash Out Proceeds",
    proceeds: [
      { term: 3, lenderProceeds: generateCashOutProceeds() },
      { term: 5, lenderProceeds: generateCashOutProceeds() },
      { term: 7, lenderProceeds: generateCashOutProceeds() },
      { term: 10, lenderProceeds: generateCashOutProceeds() },
      { term: 15, lenderProceeds: generateCashOutProceeds() },
      { term: 20, lenderProceeds: generateCashOutProceeds() },
      { term: 25, lenderProceeds: generateCashOutProceeds() }
    ]
  }
];
